__turbopack_context__.v({
  "dialogHeader": "CommandRegistryHelpDialog-module__LtvldG__dialogHeader",
  "dialogTitleGroup": "CommandRegistryHelpDialog-module__LtvldG__dialogTitleGroup",
  "listWrapper": "CommandRegistryHelpDialog-module__LtvldG__listWrapper",
  "scrollContainer": "CommandRegistryHelpDialog-module__LtvldG__scrollContainer",
});
